export default [
  {
    path: "/bulk-emails-dashboard",
    component: () => import("@/components/General/DashboardHeader.vue"),
    children: [
      {
        path: "/bulk-emails-dashboard",
        name: "bulk-emails-dashboard",
        component: () => import("./EmailsDashboard.vue"),
      },
    ],
  },
];
